/* Panier Maison Intègre : tiroir, page panier, ajout AJAX depuis les fiches produit. */
(function () {
  if (window.MICart) return;

  var root = function () { return window.Shopify && Shopify.routes ? Shopify.routes.root : '/'; };
  var drawer = function () { return document.querySelector('[data-mi-cart-drawer]'); };
  var lastFocus = null;

  function roots() { return Array.prototype.slice.call(document.querySelectorAll('[data-mi-cart-root]')); }
  function sectionIds() { return roots().map(function (r) { return r.getAttribute('data-section-id'); }).filter(Boolean); }

  function setBusy(on) {
    document.querySelectorAll('[data-mi-cart-content]').forEach(function (c) { c.classList.toggle('is-busy', on); });
  }

  function notice(msg) {
    document.querySelectorAll('[data-mi-cart-notice]').forEach(function (n) { n.textContent = msg || ''; });
  }

  /* Remplace le contenu de chaque panier avec le HTML rendu par Shopify */
  function render(sections) {
    if (!sections) return;
    roots().forEach(function (r) {
      var id = r.getAttribute('data-section-id');
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-mi-cart-content]');
      var current = r.querySelector('[data-mi-cart-content]');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        current.className = fresh.className;
      }
      var body = r.querySelector('[data-mi-cart-body]');
      if (body) updateCount(parseInt(body.getAttribute('data-count'), 10));
    });
    if (window.MI && MI.init) MI.init(document);
  }

  function updateCount(n) {
    if (isNaN(n)) return;
    document.querySelectorAll('[data-mi-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function post(url, body) {
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function change(line, qty) {
    setBusy(true);
    notice('');
    return post('cart/change.js', { line: line, quantity: qty })
      .then(function (data) {
        render(data.sections);
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: data } }));
      })
      .catch(function (err) { notice((err && (err.description || err.message)) || ''); })
      .finally(function () { setBusy(false); });
  }

  /* Ouverture et fermeture du tiroir */
  function open() {
    var d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mi-lock');
    var panel = d.querySelector('.mi-cd__panel');
    setTimeout(function () { (d.querySelector('.mi-cd__close') || panel).focus(); }, 60);
    return true;
  }

  function close() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mi-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Recharge le contenu (ex. retour arrière depuis le paiement) */
  function refresh() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  /* Ajout au panier depuis un formulaire produit */
  function add(form, submitter) {
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) return form.submit();
    var payload = { items: [{ id: parseInt(id, 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 }] };
    var props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = v;
    });
    if (Object.keys(props).length) payload.items[0].properties = props;

    if (submitter) submitter.setAttribute('aria-busy', 'true');
    setBusy(true);
    var d = drawer();
    return post('cart/add.js', payload)
      .then(function (data) {
        render(data.sections);
        notice('');
        return fetch(root() + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart } }));
        if (!d || d.getAttribute('data-open-on-add') !== 'false') open();
      })
      .catch(function (err) {
        notice((err && (err.description || err.message)) || '');
        if (d) open();
      })
      .finally(function () {
        setBusy(false);
        if (submitter) submitter.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!drawer()) return;
    e.preventDefault();
    add(form, e.submitter);
  });

  document.addEventListener('click', function (e) {
    /* Lien Panier du header : ouvre le tiroir au lieu de changer de page */
    var link = e.target.closest('a[href]');
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey && !link.closest('[data-mi-cart-root]')) {
      var path = link.pathname.replace(/\/$/, '');
      var cartPath = (root() + 'cart').replace(/\/+/g, '/');
      if (path === cartPath && drawer() && window.location.pathname.replace(/\/$/, '') !== cartPath) {
        e.preventDefault();
        var mobileNav = document.querySelector('[data-mi-drawer].is-open [data-mi-drawer-close]');
        if (mobileNav) mobileNav.click();
        open();
        return;
      }
    }
    if (e.target.closest('[data-mi-cart-close]')) { close(); return; }
    var qtyBtn = e.target.closest('[data-mi-cart-qty]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-mi-cart-line]');
      if (line) change(parseInt(line.getAttribute('data-mi-cart-line'), 10), Math.max(0, parseInt(qtyBtn.getAttribute('data-mi-cart-qty'), 10)));
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    /* Garde le focus dans le tiroir */
    if (e.key === 'Tab') {
      var f = d.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.MICart = { open: open, close: close, refresh: refresh, change: change };
})();
